import { useEffect } from 'react';

import { observer } from 'mobx-react-lite';
import styled from 'styled-components';

import { Breadcrumb } from '@components/breadcrumb';
import { Button } from '@components/button';
import { IconRedo } from '@components/icons/redo';
import { Stack } from '@components/stack';

import { Header } from 'components/headers';
import { Loading } from 'components/Loading';
import { PageContent } from 'components/Page';
import { useModal } from 'features/modals';
import { useStore } from 'models/Provider';

import { SharingJobList } from './SharingJobList';

function Sharing() {
  const { jobStore, current } = useStore();
  const sharing = jobStore.sharingList;
  const loading = !jobStore.sharingLoaded;

  useEffect(() => {
    if (current) {
      jobStore.loadSharing();
    }
  }, [current, jobStore]);

  if (!current) return null;
  return (
    <div>
      <SharingHeader />
      {loading && <Loading />}
      {current.info.banner && <CompanyBanner imgUrl={current.info.banner} />}
      <PageContent alwaysScroll={false}>
        <Stack space={2}>
          <SharingJobList jobs={sharing} hasBanner={Boolean(current.info.banner)} />
        </Stack>
      </PageContent>
    </div>
  );
}

export default observer(Sharing);

const SharingHeader = observer(() => {
  const { t } = useStore();
  const { showModal } = useModal();

  function shareModal() {
    showModal('SHARE_MODAL', {
      _container: {
        autoWidth: false,
        closeOnOverlayClickOrEsc: false,
      },
    });
  }

  return (
    <Header
      mobileTitle={t('navigation.sharing')}
      breadcrumbs={<Breadcrumb items={[{ label: t('navigation.sharing') }]} />}
      actions={
        <Button iconLeft={<IconRedo />} text={t('sharejob.button.careers')} onClick={shareModal} />
      }
    />
  );
});

const CompanyBanner = styled.div`
  background: url(${(props) => props.imgUrl}) no-repeat;
  width: 100%;
  height: 240px;
  background-size: cover;
  background-position: center;
  @media (max-width: 600px) {
    height: 160px;
  }
`;
